import { useAppContext } from "@/context/AppContext";
import { useRouter } from "next/navigation";
import ProfielBreadCrumbsV2 from "../ProfielBreadCrumbsV2";

export default function QuickstartModusSelect({
  hideTitle = false,
  hideBreadcrumbs = false
}: {
  hideTitle?: boolean;
  hideBreadcrumbs?: boolean;
}) {
  const { selectModus } = useAppContext();
  const router = useRouter();

  const startLosseOpgave = () => {
    selectModus("uitleg", "quickstart");
    router.push("/library");
  };

  return (
    <div className="px-4 md:px-8">
      {!hideTitle && (
        <div className="mb-8 mt-4 text-center">
          <h1 className="mb-2 text-3xl font-bold text-gray-800">
            Aan de slag met WisWiz
          </h1>
        </div>
      )}

      {!hideBreadcrumbs && <ProfielBreadCrumbsV2 />}

      <div className="mx-auto mt-7 max-w-xl text-center">
        <p className="text-xl font-bold text-gray-900 md:text-2xl">
          Klaar om te starten?
        </p>
        <button
          type="button"
          onClick={startLosseOpgave}
          className="group mt-6 flex w-full items-center gap-3 rounded-xl border border-mathorange/70 bg-mathorange/[0.03] px-4 py-3 text-left transition-colors hover:border-mathorange hover:bg-mathorange/[0.06] focus:outline-none focus:ring-2 focus:ring-mathorange/25 md:flex-col md:justify-center md:gap-4 md:rounded-2xl md:border-2 md:border-mathyellow md:bg-white md:px-5 md:py-7 md:text-center md:shadow-sm md:hover:bg-mathyellow/10"
        >
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-mathorange/15 text-mathorange md:h-10 md:w-10 md:rounded-xl md:shadow-sm md:ring-1 md:ring-mathorange/20 [&_svg]:h-[18px] [&_svg]:w-[18px] md:[&_svg]:h-5 md:[&_svg]:w-5">
            <LightbulbIcon />
          </span>
          <span className="flex min-w-0 flex-col items-start md:items-center">
            <span className="text-base font-bold leading-5 text-gray-800 md:text-xl md:font-semibold md:leading-6 md:text-gray-950">
              Losse opgave
            </span>
            <span className="mt-0.5 text-xs leading-5 text-gray-500 md:mx-auto md:mt-2 md:max-w-[12rem] md:text-[13px] md:font-normal md:leading-6">
              Uitleg bij de opgave waar je vastloopt
            </span>
          </span>
        </button>
      </div>
    </div>
  );
}

function LightbulbIcon() {
  return (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 1 1 7.072 0l-.548.547A3.374 3.374 0 0 0 14 18.469V19a2 2 0 1 1-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
      />
    </svg>
  );
}
